import { Text } from '@wartek-id/text'

import { DataIndukVariant } from '@/apis/types'

import { VARIANT } from '../constant'

export const DATA_INDUK_TITLE = {
  [VARIANT.SATPEN]: 'Pilih Satuan Pendidikan PAUD DIKDASMEN',
  [VARIANT.YAYASAN]: 'Pilih Yayasan',
  [VARIANT.PTK]: 'Pilih Data Pendidik dan Tenaga Kependidikan',
} as const

export const BY_PTK_TYPE = {
  pendidik: 'Pilih Data Pendidik',
  tendik: 'Pilih Data Tenaga Kependidikan',
} as const

export const TitlePage = ({
  variant = VARIANT.SATPEN,
  withPtkType = false,
  ptkType,
}: {
  variant?: DataIndukVariant
  withPtkType?: boolean
  ptkType?: string
}) => {
  return (
    <Text variant="heading-sm">
      {withPtkType && ptkType
        ? BY_PTK_TYPE[ptkType]
        : DATA_INDUK_TITLE[variant]}
    </Text>
  )
}
